<template>
  <div
    v-if="showDescription && pageConfig.description"
    class="collapse-filter-container"
  >
    <div class="_info">
      <span class="close-icon">
        <img
          :src="require('@/assets/images/modal-cross.png')"
          :alt="$t('wegow.filters.closeIconAlt')"
          @click="showDescription = !showDescription"
        />
      </span>
      <h2 class="filter-title">{{ pageConfig.title }}</h2>
      <show-more :text="pageConfig.description" :max-words="90" />
    </div>
  </div>
</template>

<script setup>
import ShowMore from "@/components/general/ui/elements/ShowMoreComponent.vue";
import { useFilter } from "@/composables/useFilter";
import { ref } from "vue";

const { pageConfig } = useFilter();
const showDescription = ref(true);
</script>

<style lang="scss">
.collapse-filter-container {
  margin-top: 40px;
  padding-top: 45px;
  padding-bottom: 100px;
  max-width: 100%;
  background-color: $inputLigthBackground;
  .filter-title {
    margin-bottom: 1rem;
  }
  ._info {
    max-width: 1200px;
    margin: auto;
    color: $white;
    h2 {
      font-size: 25px;
    }
    h3 {
      font-size: 20px;
    }
    p {
      font-size: 15px;
    }
    @media screen and (max-width: 400px) {
      padding: 0 20px;
    }
  }
  .close-icon {
    display: flex;
    justify-content: end;
    cursor: pointer;
  }
}
</style>
